import nuoYaSdkHandler from './nuo-ya'

export async function showScreenRecorder(data) {
  return reflectCallMethod('showScreenRecorder', data)
}

export function getScreenRecorderStatus(callback) {
  return registerCallback('getScreenRecorderStatus', callback)
}

export function captureWebContent(data) {
  return reflectCallMethod('captureWebContent', data)
}

export function previewImagesToShare(data) {
  return reflectCallMethod('previewImagesToShare', data)
}

export function showRightIcon(data) {
  return reflectCallMethod('showRightIcon', data)
}

/**
 * 
 * - `type`:  如果没有传 默认是 0; 0: 表示网页分享, 1： 表示图片分享, base64， 2：PDF文档, 3: Word文档, 4: Excel文档  
 */
export function shareDirect(data) {
  return reflectCallMethod('shareDirect', data)
}

function reflectCallMethod(methodName, ...args) {
  const handler = getEffectiveHandler(methodName)

  if (handler && handler[methodName]) {
    return handler[methodName](...args)
  } else {
    console.warn('Not Supported method: ', methodName)
    console.warn('该操作在当前环境中不支持')
  }
}


function registerCallback(methodName, callback) {
  const handler = getEffectiveHandler(methodName)

  if (handler && handler[methodName]) {
    return handler[methodName](callback)
  } else {
    console.warn('Not Supported method: ', methodName)
    console.warn('该操作在当前环境中不支持')
  }
}


let nativeHandler
function getEffectiveHandler(methodName) {
  if (!nativeHandler) {
    nativeHandler = getCurrentNativeBridge()
  }
  let handler
  if (nuoYaSdkHandler && nuoYaSdkHandler.supports(methodName)) {
    handler = nuoYaSdkHandler
  }
  return handler
}

function getCurrentNativeBridge() {
  const handler = nuoYaSdkHandler
  if (handler) {
    handler.init()
  }
  return handler
}


function clear() {
  showRightIcon()
}

clear()

export default {
  showScreenRecorder,
  getScreenRecorderStatus,
  captureWebContent,
  previewImagesToShare,
  showRightIcon,
  shareDirect
}
